import { useEffect, useMemo, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../../context/BetSlipContext";
import secureLocalStorage from "react-secure-storage";
import { useTabIndicator } from "../../../components/useTabIndicator";
import { AnimatePresence, motion } from "framer-motion";
const ParlaySportBook = ({
  data,
  user,
  detail,
  profileData,
  setBetSlipObject,
  favouriteList,
  position,
  BetSlip,
  addToFavioute,
}) => {
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });

  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const setParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlyBet;
  });

  const naviagte = useNavigate();
  const [header, setHeader] = useState("all");
  const [selected, setSelected] = useState("");
  const [active, setActive] = useState(
    Array.from({ length: 101 }, (_, i) => i)
  );
  const [localLimit, setLocalLimit] = useState({});
  const handelChange = (odds, item, res, e) => {
    if (!isEmpty(user)) {
      if (odds > 0) {
        setParlyBet((current) => {
          const newObj = {
            ...item,
            sportsBookSelectionObject: res,
            selectObj: res?.id,
            newEventId: detail?.eventId,
            eventName: detail?.eventName,
            marketId: detail?.marketId,
          };

          const currentList = current || [];

          const filteredList = currentList.filter(
            (temp) => temp?.newEventId !== detail?.eventId
          );

          const updatedList = [...filteredList, newObj];

          secureLocalStorage.setItem("parlyBet", updatedList);

          return updatedList;
        });
      }
    } else {
      setToastObject({
        type: "warning",
        title: "Warning",
        message: "Please login to place your bet!",
        status: true,
      });
    }
  };
  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) =>
        res?.type == "sportBook" &&
        (profileData?.arrayCheck == "details"
          ? true
          : res?.sportType == detail?.gameType)
    );
    if (!isEmpty(obj)) {
      setLocalLimit(obj);
    } else {
      setLocalLimit({
        maxAmount: 1000,
        maxProfit: 10000,
        minAmount: 1,
        oddsLimit: 10,
      });
    }
  }, []);

  const [updatedData, setUpdatedData] = useState([]);
  const reorderedData = useMemo(() => {
    if (!favouriteList?.length) return data || [];
    const favSet = new Set(favouriteList);
    return [
      ...data.filter((item) => favSet.has(item.id)),
      ...data.filter((item) => !favSet.has(item.id)),
    ];
  }, [data, favouriteList]);

  // ✅ Memoize filtered data based on header
  const filteredData = useMemo(() => {
    if (!reorderedData?.length) return [];
    const lowerCased = (str) => str?.toLowerCase() || "";

    switch (header) {
      case "Innings":
        return reorderedData.filter((res) =>
          lowerCased(res.marketName).includes("innings")
        );
      case "Over":
        return reorderedData.filter((res) => {
          const name = lowerCased(res.marketName);
          return name.includes("over") && !name.includes("winner");
        });
      case "Match":
        return reorderedData.filter((res) => {
          const name = lowerCased(res.marketName);
          return name.includes("winner") || name.includes("innings");
        });
      case "Batsman":
        return reorderedData.filter((res) => {
          const name = lowerCased(res.marketName);
          return (
            !name.includes("over") &&
            name.includes("innings") &&
            name.includes("total")
          );
        });
      default:
        return reorderedData;
    }
  }, [reorderedData, header]);

  // ✅ Set filtered data when it changes
  useEffect(() => {
    setUpdatedData(filteredData);
  }, [filteredData]);

  // ✅ Handle bet slip updates cleanly
  useEffect(() => {
    if (!(betSlipObject?.playType === "sportBook" && showBetDialog)) return;

    if (!data?.length) {
      setBetSlipObject({});
      setShowBetDialog(false);
      return;
    }

    const find = data.find((res) => res?.id === betSlipObject?.item?.id);

    if (
      isEmpty(find) ||
      [9, 2, 3, 4].includes(Number(find?.marketStatus)) ||
      !find?.sportsBookSelection?.length
    ) {
      setBetSlipObject({});
      setShowBetDialog(false);
      return;
    }

    const updatedObject = find.sportsBookSelection.find(
      (res) => res.id === betSlipObject?.object?.id
    );
    if (updatedObject?.odds !== betSlipObject?.odds) {
      setBetSlipObject((prev) => ({
        ...prev,
        object: { ...prev.object, odds: updatedObject?.odds },
        odds: updatedObject?.odds,
      }));
    }
  }, [betSlipObject, showBetDialog, data, setBetSlipObject, setShowBetDialog]);

  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  return (
    <div>
      <div
        data-v-b21f4b8c
        className="market-wrapper h-34px flex items-center bg-primary"
        style={{
          "--8f2b3936": `${indicatorStyle?.width || 16}px`,
          "--d946a2ea": `translateX(${indicatorStyle?.x + 10}px)`,
        }}
      >
        <div
          data-v-b21f4b8c
          className="relative overflow-x-scroll h-full inline-flex items-center"
        >
          <div data-v-b21f4b8c className="relative inline-block mr-2">
            <ul
              ref={containerRef}
              data-v-b21f4b8c
              className="ml-3 mr-1 h-full flex flex-nowrap justify-start items-center text-market-name space-x-7"
            >
              {premiumCategoryArray?.map((res, index) => {
                return (
                  <li
                    onClick={() => {
                      setHeader(res?.type);
                      setActiveIndex(index);
                    }}
                    data-v-b21f4b8c
                    name="All"
                    className="h-full flex items-center"
                  >
                    {res?.name}
                  </li>
                );
              })}
            </ul>
            <div
              data-v-b21f4b8c
              className="tab-indicator parlay -mx-1 mt-3px absolute rounded-full bg-market-name"
            />
          </div>
        </div>
      </div>
      {data?.length > 0 ? (
        <div className="px-2 py-2">
          {updatedData?.map((item, index) => {
            if (item?.sportsBookSelection?.length > 0) {
              let lockOuter =
                item?.apiSiteStatus == "SUSPENDED" || item?.marketStatus != 1;
              let animate = favouriteList?.includes(item.id);
              return (
                <div className="mb-2 rounded-xl bg-white p-1">
                  {" "}
                  <AnimatePresence>
                    <motion.div
                      key={item.id}
                      layout={animate} // Animate only clicked item
                      initial={animate ? { opacity: 0, y: 10 } : false}
                      animate={animate ? { opacity: 1, y: 0 } : {}}
                      exit={{ opacity: 0 }}
                      transition={{
                        type: "spring",
                        stiffness: 500,
                        damping: 30,
                        mass: 0.5,
                      }}
                    >
                      <div
                        onClick={() =>
                          setActive((prev) => {
                            if (prev.includes(index)) {
                              return prev?.filter((obj) => {
                                return obj != index;
                              });
                            } else {
                              return [...prev, index];
                            }
                          })
                        }
                        className="relative py-2 flex justify-start items-center rounded-t-lg"
                      >
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            addToFavioute(
                              detail?.eventId,
                              "SportBook",
                              item?.id
                            );
                          }}
                          className={`text-16 mx-2 icon-top${
                            animate ? "-soild" : ""
                          }`}
                        />
                        <span className="text-13 font-bold flex-1">
                          {item?.marketName}
                        </span>
                        <i
                          className={`icon-arrow-down-sencodary text-11 mr-3 justify-self-end text-black transition-transform origin-center duration-300 transform ${
                            active.includes(index) ? " rotate-180" : ""
                          }`}
                        />
                      </div>{" "}
                      {active.includes(index) && (
                        <div className="grid-cols-2 grid gap-2px relative mt-1">
                          {item?.sportsBookSelection?.map((res, id) => {
                            if (Number(res?.odds) > 0) {
                              let lock =
                                res?.isActive != 1 ||
                                item?.apiSiteStatus == "SUSPENDED" ||
                                item?.marketStatus != 1;

                              let obj =
                                parlyBet?.length > 0
                                  ? parlyBet?.find((obj) => {
                                      return (
                                        obj?.marketName == item?.marketName &&
                                        obj?.sportsBookSelectionObject?.id ==
                                          res?.id
                                      );
                                    })
                                  : {};
                              return (
                                <div
                                  onClick={(e) => {
                                    if (!lock) {
                                      handelChange(res?.odds, item, res, e);
                                      setSelected(item?.id);
                                    }
                                  }}
                                  data-v-8600fba4
                                  className={`text-center flex flex-col justify-center items-center rounded-4px relative min-h-49px bg-black-300 ${
                                    !isEmpty(obj) ? "border bg-white p-0.5" : ""
                                  }`}
                                  title="back"
                                >
                                  <div
                                    data-v-8600fba4
                                    className="flex flex-col justify-center items-center w-full h-full py-1.5"
                                  >
                                    <i
                                      data-v-8600fba4
                                      className="absolute right-1"
                                    />
                                    <h3
                                      data-v-8600fba4
                                      className="pb-1 px-2 text-11 font-normal w-full"
                                    >
                                      {res?.selectionName}
                                    </h3>
                                    <p
                                      data-v-8600fba4
                                      className="text-15 font-bold"
                                    >
                                      {res?.odds}
                                    </p>
                                    <div
                                      data-v-8600fba4
                                      className="rounded-full px-2 bg-white bg-opacity-40"
                                    ></div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                          {lockOuter && (
                            <div className="absolute w-full h-full bg-black-700 bg-opacity-80 rounded-b-md rounded-t-md">
                              <span className="w-full h-full flex justify-center items-center text-global-font-on-dark text-11">
                                Suspend
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </motion.div>
                  </AnimatePresence>
                </div>
              );
            }
          })}

          <div className="flex justify-center items-center">
            <div className="flex flex-1 justify-end items-center">
              <div
                className="flex items-center text-black-600"
                data-testid="betLimit"
              >
                <i className="px-1 mt-0.5 text-14 icon-min-max" />
                <span className="px-0.5 text-11">min</span>
                <span className="px-1 text-11 font-bold">1</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        detail?.hasSportBook &&
        detail?.premiumFancy == "on" && (
          <div class="s-bg-white s-rounded-b-xl dark:s-bg-market-tab-bg-active">
            <div class="s-bg-market-tab-active s-h-3px"></div>
            <div class="s-py-3 s-px-4 s-text-14px dark:s-text-black-500">
              Loading Market…
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ParlaySportBook;
const premiumCategoryArray = [
  { type: "all", name: "All" },
  { type: "Popular", name: "Popular" },
  { type: "Match", name: "Match" },
  { type: "Innings", name: "Innings" },
  { type: "Over", name: "Over" },
  { type: "Batsman", name: "Batsman" },
];
